import React, { useState } from 'react';
import TextField from 'apollo-react/components/TextField';
import Tooltip from 'apollo-react/components/Tooltip';
import Info from 'apollo-react-icons/Info';
import EyeShow from 'apollo-react-icons/EyeShow';
import EyeHidden from 'apollo-react-icons/EyeHidden';

function FieldLabel({ label, helpText, required }) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <span>{label}</span>
      {required && (
        <span style={{ color: '#d32f2f', fontSize: 20, lineHeight: '14px' }}>
          *
        </span>
      )}
      {helpText && (
        <Tooltip title={helpText} placement="top">
          <span style={{ display: 'inline-flex', cursor: 'pointer' }}>
            <Info fontSize="extraSmall" style={{ color: '#595959' }} />
          </span>
        </Tooltip>
      )}
    </div>
  );
}

export default function SecretInputField({
  field,
  value,
  onChange,
  disabled,
  error,
}) {
  const [showValue, setShowValue] = useState(false);
  const hasExistingValue = field.has_value;
  const isEditing = !disabled;

  const displayValue = isEditing
    ? (value ?? '')
    : hasExistingValue
      ? field.value_masked || '••••••••'
      : '';

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ marginBottom: 6 }}>
        <FieldLabel
          label={field.label}
          helpText={field.help_text}
          required={field.required}
        />
      </div>
      <TextField
        type={showValue ? 'text' : 'password'}
        value={displayValue}
        onChange={(e) => onChange(field.key, e.target.value)}
        disabled={disabled}
        error={!!error}
        helperText={error || ''}
        fullWidth
        icon={isEditing ? showValue ? <EyeHidden /> : <EyeShow /> : undefined}
        iconProps={
          isEditing
            ? { onClick: () => setShowValue((prev) => !prev) }
            : undefined
        }
      />
    </div>
  );
}
